export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--A.5085b266.png";